<template>
    <v-dialog v-model="dialog" max-width="500">
        <template v-slot:activator="{ on }">
          <v-btn  color="primary"
            outlined
            small
            dark v-on="on" style="text-transform: none !important;">{{buttonName}}</v-btn>
        </template>
        <v-card>
            <v-card-text style="height: 500px;">
                <v-row>
                    </v-card-title  class="justify-center"><span class="title pt-4">{{title}}</span></v-card-title>
                </v-row> 
                <v-row no-gutters style="height: 30px;">
                    <v-col>
                        <v-checkbox class="title" style="height: 10px;" v-model="select_all_a" :indeterminate="indeterminate_a" color="blue-dark" value="A" @change="changeCheckboxAll('A',$event)"></v-checkbox>
                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">A</div>
                    </v-col>                    
                    <v-col>
                        <v-checkbox style="height: 5px;" v-model="select_all_b" :indeterminate="indeterminate_b" color="blue-dark" value="B" @change="changeCheckboxAll('B',$event)"></v-checkbox>
                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">B</div>
                    </v-col>                  
                    <v-col>
                        <v-checkbox style="height: 5px;" v-model="select_all_bb" :indeterminate="indeterminate_bb" color="blue-dark" value="BB" @change="changeCheckboxAll('BB',$event)"></v-checkbox>
                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">BB</div>
                    </v-col>                  
                    <v-col>
                        <v-checkbox style="height: 5px;" v-model="select_all_bbb" :indeterminate="indeterminate_bbb" color="blue-dark" value="BBB" @change="changeCheckboxAll('BBB',$event)"></v-checkbox>
                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">BBB</div>
                    </v-col>                  
                    <!-- v-col>
                        <v-checkbox style="height: 5px;" v-model="select_all_belowb" :indeterminate="indeterminate_belowb" color="blue-dark" value="BelowB" @change="changeCheckboxAll('BelowB',$event)"></v-checkbox>
                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">Below B</div>
                    </v-col -->
                </v-row>
                <v-row no-gutters style="height: 30px;">
                    <v-col>
                        <v-row no-gutters style="height: 30px;" v-for="item in assets_a">
                            <v-col>
                                <v-checkbox style="height: 5px;" v-model="selected_a" :value="item" @change="changeCheckbox('A')"></v-checkbox>
                                <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{item}}</div>
                            </v-col>
                        </v-row>
                    </v-col>                    
                    <v-col>
                        <v-row no-gutters style="height: 30px;" v-for="item in assets_b">
                            <v-col>
                                <v-checkbox style="height: 5px;" v-model="selected_b" :value="item" @change="changeCheckbox('B')"></v-checkbox>
                                <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{item}}</div>
                            </v-col>
                        </v-row>
                    </v-col>                  
                    <v-col>
                        <v-row no-gutters style="height: 30px;" v-for="item in assets_bb">
                            <v-col>
                                <v-checkbox style="height: 5px;" v-model="selected_bb" :value="item" @change="changeCheckbox('BB')"></v-checkbox>
                                <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{item}}</div>
                            </v-col>
                        </v-row>
                    </v-col>                  
                    <v-col>
                        <v-row no-gutters style="height: 30px;" v-for="item in assets_bbb">
                            <v-col>
                                <v-checkbox style="height: 5px;" v-model="selected_bbb" :value="item" @change="changeCheckbox('BBB')"></v-checkbox>
                                <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{item}}</div>
                            </v-col>
                        </v-row>
                    </v-col>                  
                    <!-- v-col>
                        <v-row no-gutters style="height: 30px;" v-for="item in assets_belowb">
                            <v-col>
                                <v-checkbox style="height: 5px;" v-model="selected_belowb" :value="item" @change="changeCheckbox('BelowB')"></v-checkbox>
                                <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{item}}</div>
                            </v-col>
                        </v-row>
                    </v-col-->
                </v-row>
            </v-card-text>
            <v-card-text>
                <v-row no-gutters style="height: 30px;">
                    <v-col col="3">
                        <v-checkbox style="height: 5px;" v-model="selected_include_regions" color="blue-dark" value="INCLUDE_REGIONS" @change="refresheSelected()"></v-checkbox>                    
                        <div class="cell_left_pad" style="height: 20px; font-size: 12px !important;">Include Regions in the Chart</div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions  align-center justify-center>
                <v-btn outlined color="indigo" small text @click="dialog = false">Close</v-btn>
                <v-spacer></v-spacer>
                <v-btn outlined color="indigo" small text @click="updateChartSeries()">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>   
</template>
<script>
export default {
    props:{
        buttonName: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        assets: {
            type: Array,
            default () {
                return []
            }
        },
        initialSelect: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data(){
        return {
            select_all_a: 'A',
            select_all_b: 'B',
            select_all_bb: 'BB',
            select_all_bbb: 'BBB',            
            select_all_belowb: 'Below_B',

            selected_include_regions: 'INCLUDE_REGIONS',
            selected_a: [],
            selected_b: [],
            selected_bb: [],
            selected_bbb: [],
            selected_belowb: [],
            selected: this.initialSelect,
            indeterminate: false,
            indeterminate_a: true,
            indeterminate_b: true,
            indeterminate_bb: true,
            indeterminate_bbb: true,
            indeterminate_belowb: true,
            dialog: false,
            assets_a: [],
            assets_b: [],
            assets_bb: [],
            assets_bbb: [],
            assets_belowb: []
        }
    },
    created(){
        if( _.size(this.selected)!= _.size(this.assets))
            this.indeterminate= false;
        else 
            this.indeterminate= true;
    },
    watch: {
        assets: function (val) {            
            this.loadAssetsGroups();
        }
    },
    methods:{        
        loadAssetsGroups(){
            var me = this;
            _.forEach(this.assets, function(item) {
                switch(item.groupname)
                {
                    case "A":
                        me.assets_a.push(item.name);
                    break;
                    case "B":
                        me.assets_b.push(item.name);
                    break;
                    case "BB":
                        me.assets_bb.push(item.name);
                    break;
                    case "BBB":
                        me.assets_bbb.push(item.name);
                    break;
                    case "Below_B":
                        me.assets_belowb.push(item.name);
                    break;
                }
            });
        },
        changeCheckboxAll(groupname,event){
            switch(groupname)
            {
                case "A":
                    if(!this.indeterminate_a ){     
                        if(event){
                            this.select_all_a='A';             
                            this.indeterminate_a = false;
                            this.selected_a = _.cloneDeep(this.assets_a);
                        }
                        else{
                            this.indeterminate_a = true;
                            this.select_all_a='A';
                            this.selected_a = [];
                        }
                    }else{                    
                        this.indeterminate_a = false;
                        this.select_all_a=null;
                        this.selected_a = [];
                    }
                break;
                case "B":                    
                    if(!this.indeterminate_b ){  
                        if(event){
                            this.select_all_b='B';             
                            this.indeterminate_b = false;
                            this.selected_b = _.cloneDeep(this.assets_b);
                        }
                        else{
                            this.indeterminate_b = true;
                            this.select_all_b='B';
                            this.selected_b = [];
                        }
                    }else{                    
                        this.indeterminate_b = false;
                        this.select_all_b=null;
                        this.selected_b = [];
                    }
                break;
                case "BB":                    
                    if(!this.indeterminate_bb ){  
                        if(event){
                            this.select_all_bb='BB';             
                            this.indeterminate_bb = false;
                            this.selected_bb = _.cloneDeep(this.assets_bb);
                        }
                        else{
                            this.indeterminate_bb = true;
                            this.select_all_bb='BB';
                            this.selected_bb = [];
                        }
                    }else{                    
                        this.indeterminate_bb = false;
                        this.select_all_bb=null;
                        this.selected_bb = [];
                    }
                break;
                case "BBB":                    
                    if(!this.indeterminate_bbb ){  
                        if(event){
                            this.select_all_bbb='BBB';             
                            this.indeterminate_bbb = false;
                            this.selected_bbb = _.cloneDeep(this.assets_bbb);
                        }
                        else{
                            this.indeterminate_bbb = true;
                            this.select_all_bbb='BBB';
                            this.selected_bbb = [];
                        }
                    }else{                    
                        this.indeterminate_bbb = false;
                        this.select_all_bbb=null;
                        this.selected_bbb = [];
                    }
                break;                
                case "Below_B":                    
                    if(!this.indeterminate_belowb ){  
                        if(event){
                            this.select_all_belowb='Below_B';             
                            this.indeterminate_belowb = false;
                            this.selected_belowb = _.cloneDeep(this.assets_belowb);
                        }
                        else{
                            this.indeterminate_belowb = true;
                            this.select_all_belowb='Below_B';
                            this.selected_belowb = [];
                        }
                    }else{                    
                        this.indeterminate_belowb = false;
                        this.select_all_belowb=null;
                        this.selected_belowb = [];
                    }
                break;
            }
            this.refresheSelected();
        },
        changeCheckbox(groupname){
            switch(groupname)
            {
                case "A":
                    if(_.size(this.selected_a)!=_.size(this.assets_a)){
                        this.indeterminate = true;
                        this.indeterminate_a = true;
                    }
                    else
                        this.indeterminate_a = false;                    
                break;
                case "B":
                    if(_.size(this.selected_b)!=_.size(this.assets_b)){
                        this.indeterminate = true;
                        this.indeterminate_b = true;
                    }
                    else
                        this.indeterminate_b = false;
                break;
                case "BB":
                    if(_.size(this.selected_bb)!=_.size(this.assets_bb)){
                        this.indeterminate = true;
                        this.indeterminate_bb = true;
                    }
                    else
                        this.indeterminate_b = false;
                break;
                case "BBB":
                    if(_.size(this.selected_bbb)!=_.size(this.assets_bbb)){
                        this.indeterminate = true;
                        this.indeterminate_bbb = true;
                    }
                    else
                        this.indeterminate_b = false;
                break;
                case "Below_B":
                    if(_.size(this.selected_belowb)!=_.size(this.assets_belowb)){
                        this.indeterminate = true;
                        this.indeterminate_belowb = true;
                    }
                    else
                        this.indeterminate_belowb = false;
                break;
            }
            this.refresheSelected();
            if(_.size(this.selected)>0 && (_.size(this.selected_a)+_.size(this.selected_b)+_.size(this.selected_bb)+_.size(this.selected_belowb))<_.size(this.assets))
                this.indeterminate = true;
            else{
                if(_.size(this.selected)>0)
                    this.indeterminate = false;
            }            
        },
        refresheSelected(){
            this.selected = _.concat(this.selected_a,this.selected_b,this.selected_bb,this.selected_bbb,this.selected_belowb);

            if(this.selected_include_regions){
                if(this.select_all_a)
                    this.selected = _.concat(this.selected,this.select_all_a);
                    
                if(this.select_all_b)
                    this.selected = _.concat(this.selected,this.select_all_b);
                
                if(this.select_all_bb)
                    this.selected = _.concat(this.selected,this.select_all_bb);
                
                if(this.select_all_bbb)
                    this.selected = _.concat(this.selected,this.select_all_bbb);
                
                if(this.select_all_belowb)
                    this.selected = _.concat(this.selected,this.select_all_belowb);
            }
        },
        updateChartSeries(){
            this.$emit('updateChartSeries',this.selected);
            this.dialog=false;
        }
    }
}
</script>
<style scoped>
    .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio{
        font-size: 13px;
        font-weight: 600;
    }
    .title{
        font-size: medium !important;
        color: #003498 !important;
    }
    .cell_left_pad{        
        padding-left: 25px;
    }
</style>